import React, { useState } from "react";
import { RotateCcw } from "lucide-react";
import DangerConfirmModal from "../DangerConfirmModal";
import { resetDemo } from "../../lib/demoExperience";
import { resetHostDemo } from "../../lib/demoHostExperience";
import { CLASS_DEMO_PATH, resetClassDemo } from "../../lib/demoClassExperience";
import { SCHOOL_DEMO_PATH, resetSchoolDemo } from "../../lib/demoSchoolExperience";

export default function DemoResetPill({ inline = false, variant = "guest" }) {
  const [confirmOpen, setConfirmOpen] = useState(false);
  const isHost = variant === "host";
  const isClass = variant === "class";
  const isSchool = variant === "school";

  function handleConfirm() {
    if (isSchool) {
      resetSchoolDemo({ redirectTo: SCHOOL_DEMO_PATH });
    } else if (isClass) {
      resetClassDemo({ redirectTo: CLASS_DEMO_PATH });
    } else if (isHost) {
      resetHostDemo();
    } else {
      resetDemo();
    }
  }

  const message = isSchool
    ? "This clears door check-ins and fee approvals on this device."
    : isClass
      ? "This clears your class RSVP, attendance marks, and walk-ins on this device."
      : isHost
        ? "This clears your demo dashboard changes and restarts the guided tour on this device."
        : "This clears your RSVP, check-in, board posts, and votes on this device.";

  return (
    <>
      <button
        type="button"
        onClick={() => setConfirmOpen(true)}
        className={`${
          inline ? "relative shrink-0" : "fixed top-[max(1rem,env(safe-area-inset-top))] right-4 z-50"
        } rounded-md2 bg-white px-3 py-2 min-h-[44px] inline-flex items-center gap-1.5 font-ui font-medium text-[13px] border border-black/[0.08] focus-visible:outline focus-visible:outline-2 focus-visible:outline-orchid/45 focus-visible:outline-offset-2`}
        data-testid="demo-reset-pill"
        aria-label="Reset demo and start over"
      >
        <RotateCcw className="w-3.5 h-3.5" strokeWidth={2.5} aria-hidden />
        Reset
      </button>

      <DangerConfirmModal
        open={confirmOpen}
        title="Reset demo?"
        message={message}
        confirmLabel="Reset demo"
        onClose={() => setConfirmOpen(false)}
        onConfirm={handleConfirm}
        tone="neutral"
        testId="demo-reset-confirm"
      />
    </>
  );
}
